import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const PEParentsIncomeRowActions = {
  initPeParentsIncomeRow: ({ commit }, index) => {
    commit('setPeParentsIncomeRowLock', { index, lock: true })
  },
  peParentsIncomeRefreshAll: ({ state, dispatch, commit }) => {
    for (const parent of state.partyEdit.party.parents) {
      dispatch('peParentsCardRefresh', { section: parent, index: parent.id })
      commit('setPeParentsIncomeRowLock', { index: parent.id, lock: true })
    }
  },
  peParentsIncomeRowUpdate: async ({ commit, getters }, { id, section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      patch(`/party_characteristics/${id}`, {
        parents: {
          party_id: party.id,
          monthly_income: section.monthly_income,
          income_verification: section.income_verification,
        },
        id,
      }).
      then(({ data }) => {
        const updatedParty = data.party

        commit('setPeParentsIncomeRowLock', { index, lock: true })
        commit('pePatchParty', {
          parents: updatedParty.parents || [],
        })
      }).
      catch(handleError)
  },
}

export const PEParentsIncomeRowMutations = {
  setPeParentsIncomeRowLock: (state, { index, lock }) => {
    if (!state.partyEdit.partySections.ParentsIncomeRow) Vue.set(state.partyEdit.partySections, 'ParentsIncomeRow', {})
    Vue.set(state.partyEdit.partySections.ParentsIncomeRow, index, lock)
  },
}

export const PEParentsIncomeRowGetters = {
  peParentsIncomeRowLock: state => index => state.partyEdit.partySections.ParentsIncomeRow[index],
}
